// src/pages/LegendHubHome.jsx
import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { logout } from "../../redux/actions/authActions";

const LegendHubHome = () => {
  const authState = useSelector((state) => state.authReducer || {});
  const isLoggedIn = authState?.isLoggedIn || false;
  const userName = authState?.user?.name || "User";

  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [activeTab, setActiveTab] = useState("CLE");

  const handleLogout = () => {
    dispatch(logout());
    navigate("");
  };

  const groupNames = [
    { label: "CLE", emoji: "📚" },
    { label: "LEGEND Productivity", emoji: "⚡" },
    { label: "Self & Community", emoji: "👥" },
    { label: "Market & Engagement", emoji: "🛒💬" },
  ];

  const menuButtons1 = [
    { label: "CLE - Continuing Legal Education", emoji: "📚", link: "/legend-bookworld", group: "CLE" },
    { label: "LEGEND Shelf", emoji: "📖", link: "/bookshelf", group: "CLE" },
    { label: "Law Shorts", emoji: "🗞️", link: "/litenshort", group: "CLE" },
    { label: "Law Trainings & Workshops", emoji: "🎓", link: "/enroll/workshop", group: "CLE" },
    { label: "Law Podcast", emoji: "️🎙️", link: "/podcast-mylist", group: "CLE" },
    { label: "legendTube", emoji: "️🎙️", link: "/legendtube", group: "CLE" },
    { label: "ValueShare", emoji: "💾", link: "/orderflow-earning-estimator", group: "CLE" },
    // { label: "Stakeholders", emoji: "👨‍💼", link: "/legend-think5whysroles", group: "CLE" },

    { label: "LEGEND Ranking", emoji: "🏆", link: "/legendscore", group: "Self & Community" },
    { label: "LEGEND Database", emoji: "💾", link: "/legenddb", group: "Self & Community" },
    { label: "Digital Card", emoji: "📘", link: "/legend-digitalcard", group: "Self & Community" },

    { label: "Ask AI", emoji: "🤖", link: "/agenticsim", group: "LEGEND Productivity" },
    { label: "DeepThinking Lab", emoji: "🧩", link: "/fivewhys-analysis-home", group: "LEGEND Productivity" },
    { label: "My Chronicles", emoji: "📘", link: "/life-chronicles-home", group: "LEGEND Productivity" },

    { label: "Counselling", emoji: "🧠", link: "/aicounselling-about", group: "People & Innovation" },
    { label: "Digital Boutique", emoji: "🛍️", link: "/digiboutique", group: "People & Innovation" },
    { label: "Consultants", emoji: "👨‍💼", link: "/think5whys-counsellors", group: "People & Innovation" },

    { label: "Services", emoji: "🧰", link: "/think-service-home", group: "Market & Engagement" },
    { label: "Rental", emoji: "🏨", link: "/think-rent-home", group: "Market & Engagement" },
    { label: "Marketplace", emoji: "🛒", link: "/orderflow-home", group: "Market & Engagement" },
    { label: "TwiWrold", emoji: "🌐", link: "/twiworld", group: "Market & Engagement" },
    { label: "Legend MetaVerse", emoji: "🕶️", link: "/legend-metaverse", group: "Market & Engagement" },
    { label: "Forum", emoji: "🗣️", link: "/povify-home", group: "Market & Engagement" },
  ];

  const filteredButtons = menuButtons1.filter((btn) => btn.group === activeTab);

  return (
    <div className="min-h-screen flex flex-col bg-black text-gray-100 font-sans">
      <header className="sticky top-0 z-50 bg-black border-b border-gray-800 px-4 py-3 flex items-center justify-between">
        <div className="flex flex-col">
          <div className="text-xl font-bold text-yellow-200">⚖️ LEGEND</div>
          <div className="text-[11px] text-gray-400">Legal Education for Global Expertise & New Developments</div>
          <div className="text-[11px] text-yellow-200">CLE ecosystem that bridges academia, bar councils and real-world legal practice</div>
        </div>

        <div className="hidden md:flex items-center gap-3">
          {isLoggedIn ? (
            <>
              <div className="text-xs text-yellow-200">{userName}</div>
              <button
                onClick={handleLogout}
                className="mt-2 p-2 rounded-md bg-red-600 hover:bg-red-700 transition"
                title="Logout"
              >
                ⏻
              </button>
            </>
          ) : (
            <>
              <button
                onClick={() => navigate("/login")}
                className="px-3 py-1 rounded-full border border-gray-700 text-sm text-gray-200 hover:bg-gray-800"
              >
                Login
              </button>
            </>
          )}
        </div>

        {/* Mobile hamburger (w-10) */}
        <button
          onClick={() => setIsMobileMenuOpen((s) => !s)}
          className="md:hidden w-10 h-10 flex items-center justify-center text-2xl text-blue-300"
          aria-label="Toggle menu"
        >
          {isMobileMenuOpen ? "×" : "☰"}
        </button>
      </header>

      {/* Mobile menu content */}
      {isMobileMenuOpen && (
        <div className="md:hidden bg-gray-900 border-b border-gray-800 px-4 py-3">
          {isLoggedIn ? (
            <div className="flex flex-col items-center gap-3">
              <div className="text-yellow-200 text-xs">{userName}</div>
              <div className="flex gap-3">
                <button
                  onClick={handleLogout}
                  className="mt-2 p-2 rounded-md bg-red-600 hover:bg-red-700"
                >
                  ⏻
                </button>
              </div>
            </div>
          ) : (
            <div className="flex justify-center gap-6">
              <Link to="/login" className="text-blue-400">Login</Link>
            </div>
          )}
        </div>
      )}

      {/* Top quick links (desktop + mobile inline area) */}
      <div className="bg-cyan-800 text-white text-xs sm:text-sm py-2">
        <div className="max-w-6xl mx-auto px-3 flex flex-wrap justify-center gap-4">
          <a href="/Legend-insights" className="hover:text-yellow-200">💭 About Legend</a>
          <Link to="/litenshort" className="hover:text-yellow-200">🗞️ Short News</Link>
          <a href="/Legend-think5whysfaq" className="hover:text-yellow-200">🤔 FAQ</a>
        </div>
      </div>

      {/* Tabs (categories) */}
      <div className="mt-1 mb-1 px-3 py-2 border-b border-gray-500">
        <div className="grid grid-cols-4 lg:grid-cols-4 gap-0  border-gray-600 place-items-center">
          {groupNames.map((group) => (
            <button
              key={group.label}
              onClick={() => setActiveTab(group.label)}
              className={`flex flex-col items-center justify-center w-full px-2 py-2 rounded-md text-xs sm:text-sm font-medium transition ${
                activeTab === group.label
                  ? "bg-blue-700 text-yellow-200"
                  : "bg-gray-800 text-gray-200 hover:bg-gray-700"
              }`}
              aria-pressed={activeTab === group.label}
            >
              <span className="text-lg">{group.emoji}</span>
              <span className="mt-1 text-center">{group.label}</span>
            </button>
          ))}
        </div>
      </div>

      {/* Main content area with grid of buttons */}
      <main className="flex-grow mx-auto px-3 py-2 w-full justify-center items-center text-center">
        <div className="grid grid-cols-3 sm:grid-cols-3 md:grid-cols-5 gap-0 place-items-center">
          {filteredButtons.length === 0 ? (
            <div className="col-span-3 sm:col-span-3 md:col-span-5 text-center text-gray-400">
              No items in this category.
            </div>
          ) : (
            filteredButtons.map((btn, idx) => (
              <button
                key={`${btn.label}-${idx}`}
                onClick={() => navigate(btn.link)}
                className="flex flex-col items-center justify-center w-full px-1.5 py-1 rounded-md text-[10px] sm:text-xs font-medium transition bg-transparent hover:bg-blue-700 hover:text-yellow-200 text-gray-100 break-words text-center shadow-sm"
                title={btn.label}
              >
                <span className="text-base sm:text-lg">{btn.emoji}</span>
                <span className="mt-1">{btn.label}</span>
              </button>
            ))
          )}
        </div>
      </main>

      {/* Footer */}
      <footer className="bg-black border-t border-blue-400 text-white py-4">
        <div className="max-w-6xl mx-auto px-3 flex flex-col md:flex-row items-center justify-between gap-3">
          <div className="text-sm">© 2025 Think5Whys Global DeepTech Solutions.</div>
          <div className="flex flex-wrap gap-4 text-sm">
            <Link to="/about-us" className="hover:text-blue-300">About</Link>
            <Link to="/privacy-policy" className="hover:text-blue-300">Privacy Policy</Link>
            <Link to="/terms-of-use" className="hover:text-blue-300">Terms of Use</Link>
            <Link to="/contact-us" className="hover:text-blue-300">Contact</Link>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default LegendHubHome;
